import { Navigate } from "react-router-dom";

// The admin console lives inside the dashboard now; keep old /admin links working.
export function AdminPage() {
  return <Navigate to="/app/admin" replace />;
}
